import store from '@/store';
const slotsAvailable = (value) => {
    var _a, _b;
    const reservation = value;
    const multiDaySummary = store.getters.daysummaries.multidaySummary;
    const numberOfSpots = (_b = (_a = store.state.locations.locations[reservation.location]) === null || _a === void 0 ? void 0 : _a.numberOfSpots) !== null && _b !== void 0 ? _b : 0;
    return multiDaySummary.numOpenSpots(reservation.fromDate, reservation.toDate, numberOfSpots) > 0;
};
export default slotsAvailable;
